$( document ).on("turbo:load", initOverview);

function initOverview() {
  if ($("[data-function='trim-copy']").length > 0) {
    $("[data-function='trim-copy']").on("click", function(event){
      event.preventDefault();
      maxSize = 200;
      from = $($(this).data("from"));
      to = $($(this).data("to"));
      content = from.val();
      if (content.length > maxSize) {
        content = content.substring(0, maxSize) + "...";
      } 
      to.val(content);
    });        
  }
}

